export default "__VITE_ASSET__ID5iYOIx__"